export default "__VITE_ASSET__DjBfXYbq__"